import { createReducer } from '@reduxjs/toolkit';

import { fetchMediaSetRequirements } from './actions';

export default createReducer([], {
  [`${fetchMediaSetRequirements}-success`]: (
    state,
    { payload: mediaSetRequirements },
  ) => mediaSetRequirements,
});
